import styles from './CircledChevronLeft.module.scss';
import classNames from 'classnames/bind';

let cx = classNames.bind(styles);

export function CircledChevronLeft({ className }) {
	const classNameArray = className?.split(' ') || [];
	return (
    <svg width="100%" viewBox="0 0 26 27" fill="none" xmlns="http://www.w3.org/2000/svg" className={cx(['circled-chevron-left-icon', ...classNameArray])} aria-hidden="true">
      <rect x=".443" y=".943" width="25.114" height="25.114" rx="12.557" fill="#000"/>
      <path d="m14.476 7.591-6.204 5.91 6.204 6.204" stroke="#FFFFFF" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
	);
}
